export const getDefaultImportType = (dictionary: Record<string, string[]> | undefined, project: string): string => {
  return dictionary && dictionary[project] && dictionary[project].length > 0 ? dictionary[project][0] : ''
}

export const getImportTypesForProject = (
  dictionary: Record<string, string[]> | undefined,
  projectName: string
): string[] => {
  if (!projectName || !dictionary || !dictionary[projectName] || !dictionary[projectName].length) {
    return []
  }
  return dictionary[projectName]
}
